export default "__VITE_ASSET__799a2bc2__"